export const css = {
    root: '_16PlkoMx',
    assess_card: '_2ZJ98Q7r',
    title: '_2DXFxnBD',
    actions: '_2Sov8WgP',
    ' _key': 'ascm-theme/ascm/explore-view/nav-card'
};
export default css;
